/**
 * Registry of per-namespace state resetters. Each namespace store registers a
 * single `reset` callback on first initialization; the connection store
 * invokes them on connect/disconnect/error so that stale device, event, and
 * listener state never leaks across connections.
 */
const resetters = new Set<() => void>();

export const registerNamespaceResetter = (reset: () => void) => {
  resetters.add(reset);
  return () => resetters.delete(reset);
};

export const resetAllNamespaces = () => {
  for (const reset of resetters) {
    try {
      reset();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("Failed to reset qz namespace state", error);
    }
  }
};
